import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class UpdateDocumentDetailService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following AngularJS service pattern exactly
  updateDetailsEntities(
    baseUrl: string,
    returnClobSettingsObj: any,
    Details: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action codes like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=jgx8x6`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    // Start with globalService and merge with filterParams
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // Build clob_settings exactly as specified: {"sso_id":"...","combination_key":"..."}
    const clobSettings: any = {
      sso_id: returnClobSettingsObj?.sso_id || globalService?.sso_id || '',
      combination_key: returnClobSettingsObj?.combination_key || ''
    };
    
    // Build clob_data from Details array
    const clobData = Details || [];
    
    // Build checkLockedbj array from clob_data items
    const checkLockedbj: any[] = [];
    if (clobData && clobData.length > 0) {
      // Build checkLockedbj for each item in clob_data
      clobData.forEach((item: any) => {
        checkLockedbj.push({
          leid: item.LEID || item.leid || '',
          me_code: item.ME_CODE || item.me_code || 'CK2000',
          cdr_number: item.CDR_NO || item.cdr_number || '',
          reporting_period: item.REPORTING_PERIOD || item.reporting_period || 1,
          combination_key: item.COMBINATION_KEY || item.combination_key || returnClobSettingsObj?.combination_key || '',
          scenario_key: parseInt(filterParams?.scenario || globalService?.scenario || params?.scenario || '74')
        });
      });
    }
    
    // Build the complete params object exactly as specified
    params = {
      clob_settings: JSON.stringify(clobSettings),
      clob_data: JSON.stringify(clobData),
      tax_year: filterParams?.tax_year || globalService?.tax_year || params?.tax_year || '2024',
      screen_key: filterParams?.screen_key || globalService?.screen_key || params?.screen_key || '',
      scenario: filterParams?.scenario || globalService?.scenario || params?.scenario || '74',
      jcd_key: filterParams?.jcd_key || globalService?.jcd_key || params?.jcd_key || '250',
      jcd_ta_key: filterParams?.jcd_ta_key || globalService?.jcd_ta_key || params?.jcd_ta_key || '',
      activity_key: filterParams?.activity_key || globalService?.activity_key || params?.activity_key || '',
      screen_type: 'grid',
      is_locked: 'N',
      issue_id: filterParams?.issue_id || globalService?.issue_id || params?.issue_id || '',
      issue_short_desc: filterParams?.issue_short_desc || globalService?.issue_short_desc || params?.issue_short_desc || '',
      issue_id_for_tx_save: filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || params?.issue_id_for_tx_save || '',
      checkLockedbj: JSON.stringify(checkLockedbj),
      scenarioCode: filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF',
      is_issue_key_enabled: filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N',
      combination_key: returnClobSettingsObj?.combination_key || '',
      process_name: 'Update Document Details'
    };

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

